
import { combineReducers } from 'redux';
import workdays from './workdays-reducer';
import workday from './workday-reducer';
import modals from './modal-reducer';
import role from './role-reducer';
import paginationState from './pagination-reducer';
import authState from './auth-reducer';
import filter from './filters';
import printState from './PDFPrinting';
import notificationState from './Notification';
import notes from './notes-reducer';
import popupmessage from './popupmessage-reducer';
import { loadingBarReducer } from 'react-redux-loading-bar';
import configurations from './configurations-reducer';
import FRA from './fra-reducer';
import series from './series-reducer';
import coverLoadingState from './cover-loading-reducer';

/*
 * We combine all reducers into a single object before updated data is dispatched (sent) to store
 * Your entire applications state (store) is just whatever gets returned from all your reducers
 * */
 
const allReducers = combineReducers({   
  
    workdays,
    workday,
    modals,
    role,
    paginationState,
    authState,
    filter,
    printState,
    notes,
    notificationState,
    loadingBar: loadingBarReducer,
    configurations,
    popupmessage,
    FRA,
    series,
    coverLoadingState,
  

});

export default allReducers